import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { deviceDurations } from "@/api/dataAll/deviceDuration";
import * as echarts from "echarts";
export default {
  name: "deviceDuration",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      tableTitle: [],
      value2: [],
      tableData: [],
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      selectedArr: {}
    };
  },
  created: function created() {},
  methods: {
    searchClicknew: function searchClicknew() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var queue, dates, datesList, i, _list, list, _i, qd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.reqLoading = true;
                queue = [];
                dates = _this.$times.getDayAll(_this.value2[0], _this.value2[1]);
                datesList = [];

                for (i = 0; i < dates.length; i += 10) {
                  _list = dates.slice(i, i + 10);
                  datesList.push({
                    starttime: _list[0],
                    endtime: _list[_list.length - 1]
                  });
                } // datesList.forEach(i => {
                //   queue.push(accountDurations({ ...this.searchData, ...i }))
                // })


                list = [];
                _i = 0;

              case 7:
                if (!(_i < datesList.length)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 10;
                return deviceDurations(_objectSpread(_objectSpread({}, _this.searchData), datesList[_i]));

              case 10:
                qd = _context.sent;

                if (qd.status == 200) {
                  list.push(qd.data);
                }

              case 12:
                _i++;
                _context.next = 7;
                break;

              case 15:
                _this.searchClick(list);

                _this.reqLoading = false; // return await Promise.resolve(list)

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(list) {
      var _this2 = this;

      var res = {
        data: {
          data: {}
        }
      };
      list.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
      });
      this.dates = [];
      this.series = [];
      var columns = [{
        label: this.$t('gameDuration'),
        prop: 'length'
      }];
      var data = [];
      var num = 0;
      var knum = 0;

      for (var i in res.data.data) {
        this.dates.push(i);
        num += 1;
        columns.push({
          label: i,
          prop: num + 'Number'
        });
        var obj = {
          name: i,
          type: "bar",
          data: [],
          smooth: true
        };

        for (var k in res.data.data[i]) {
          knum += 1;
          data.push({
            length: k
          });
          data[knum - 1][num + 'Number'] = res.data.data[i][k];
          obj.data.push(res.data.data[i][k]);

          if (knum == 13) {
            knum = 0;
          }
        }

        this.series.push(obj);
      }

      data.splice(13, data.length - 13);
      this.tableData = data;
      this.Dynamic = columns;
      this.datas = data.map(function (i) {
        return i['length'];
      });
      this.getechart();
      this.$nextTick(function () {
        _this2.getTableRight();
      });
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("deviceDurationEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('deviceOnlineDuration')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          // 这里显示点击搜索的日期--图表的最上面
          width: '80%' // selected: this.selectedArr,

        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.datas
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      this.$export.excel({
        columns: this.Dynamic,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};